import type { InternalAxiosRequestConfig } from "axios";
import useOAuthService from "../../../services/o-auth";
import { isEOSRequestConfig } from "../index.types";

const useOAuthInterceptor = () => {
	const service = useOAuthService();

	return async (config: InternalAxiosRequestConfig) => {
		try {
			if (!isEOSRequestConfig(config)) return config;
			if (config.OAuth?.enabled && config.OAuth?.resource) {
				config.headers.Authorization = await service.findOAuthToken(
					config.OAuth.resource,
				);
			}
			return config;
		} catch (err) {
			return Promise.reject(err);
		}
	};
};

export default useOAuthInterceptor;
